import React from 'react';

type CloseNewIconProps = React.SVGProps<SVGSVGElement> & {
  strokeWidth?: number;
};

export const CloseNewIcon = ({ strokeWidth, ...props }: CloseNewIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      {...props}
      viewBox="0 0 24 24"
    >
      <path
        fill="currentColor"
        stroke={strokeWidth !== undefined ? 'currentColor' : undefined}
        strokeWidth={strokeWidth}
        d="M19.62 20.88 12 13.274 4.38 20.88l-1.26-1.26L10.726 12 3.12 4.38l1.26-1.26L12 10.726l7.62-7.606 1.26 1.26L13.274 12l7.606 7.62-1.26 1.26Z"
      />
    </svg>
  );
};
